import { render, staticRenderFns } from "./adiaClassAdd.vue?vue&type=template&id=3aef06f9&scoped=true&"
import script from "./adiaClassAdd.vue?vue&type=script&lang=js&"
export * from "./adiaClassAdd.vue?vue&type=script&lang=js&"
import style0 from "./adiaClassAdd.vue?vue&type=style&index=0&id=3aef06f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef06f9",
  null
  
)

export default component.exports